type Stage = { nome: string; descricao: string; agentMainObjective: string; exemplosMensagens: string };
type Draft = {
  nome: string; aiAgentName: string; personalidade: string; regrasComunicacao: string;
  contextoEmpresa: string; escopoLimites: string; restricoes: string;
  suggestedCategories: Stage[]; desiredCategoryCount: string;
  companyContextExtra: string; scopeExtras: string; neverDo: string;
};

export const stageCriteriaFields = [
  { key: 'entrar', marker: 'Entrar quando', label: 'Quando entrar nesta etapa', placeholder: 'Qual sinal ou informação confirma que esta é a etapa certa?' },
  { key: 'permanecer', marker: 'Permanecer enquanto', label: 'Quando continuar nesta etapa', placeholder: 'O que ainda precisa ser esclarecido ou resolvido?' },
  { key: 'sair', marker: 'Sair quando', label: 'Quando avançar ou encerrar', placeholder: 'Qual evidência confirma que o objetivo foi atingido?' },
  { key: 'excluir', marker: 'Nao usar quando', label: 'Quando usar outra etapa', placeholder: 'Que situação deve seguir outro caminho?' },
] as const;

export function readStageCriteria(description: string): Record<string, string> {
  const values: Record<string, string> = {};
  for (const field of stageCriteriaFields) {
    const marker = field.marker.replace('Nao', 'N[aã]o');
    const match = description.match(new RegExp(`${marker}:\\s*([\\s\\S]*?)(?=(?:Entrar quando|Permanecer enquanto|Sair quando|N[aã]o usar quando):|$)`, 'i'));
    values[field.key] = match?.[1]?.trim() || '';
  }
  return values;
}

export function writeStageCriterion(description: string, key: string, value: string): string {
  const values = { ...readStageCriteria(description), [key]: value };
  return stageCriteriaFields.map((field) => `${field.marker}: ${values[field.key]}`).join('\n');
}

export function getAgenticDraftIssues(draft: Draft): string[] {
  const issues: string[] = [];
  const fields = ['nome', 'aiAgentName', 'personalidade', 'regrasComunicacao', 'contextoEmpresa', 'escopoLimites', 'restricoes'] as const;
  const labels = ['nome do funil', 'nome do agente', 'personalidade', 'regras', 'contexto', 'escopo', 'restrições'];
  fields.forEach((field, index) => { if (!draft[field].trim()) issues.push(`Preencha ${labels[index]}.`); });
  if (draft.companyContextExtra.trim() || draft.scopeExtras.trim() || draft.neverDo.trim()) issues.push('Aplique as correções pendentes de contexto, escopo ou restrições.');
  if (draft.suggestedCategories.length < 2 || draft.suggestedCategories.length > 7) issues.push('Defina entre 2 e 7 etapas.');
  if (draft.desiredCategoryCount && Number(draft.desiredCategoryCount) !== draft.suggestedCategories.length) issues.push('A quantidade de etapas não corresponde à quantidade escolhida.');
  const names = new Set<string>();
  for (const [index, stage] of draft.suggestedCategories.entries()) {
    const name = stage.nome.trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    if (!name || stage.nome.length > 80 || names.has(name)) issues.push(`Revise o nome da etapa ${index + 1}: use um nome único de até 80 caracteres.`);
    names.add(name);
    if (!stage.agentMainObjective.trim() || !stage.exemplosMensagens.trim()) issues.push(`Complete objetivo e exemplos da etapa ${index + 1}.`);
    const description = stage.descricao.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    for (const marker of ['entrar quando:', 'permanecer enquanto:', 'sair quando:', 'nao usar quando:']) {
      const position = description.indexOf(marker);
      const value = position < 0 ? '' : description.slice(position + marker.length).split(/(?:entrar quando|permanecer enquanto|sair quando|nao usar quando):/)[0].trim();
      if (!value || /^[.\-\s]*$/.test(value)) issues.push(`Etapa ${index + 1}: preencha "${marker}".`);
    }
  }
  return issues;
}
